import { render, staticRenderFns } from "./BaseLabelWithPopover.vue?vue&type=template&id=768a488c&scoped=true&"
import script from "./BaseLabelWithPopover.vue?vue&type=script&lang=js&"
export * from "./BaseLabelWithPopover.vue?vue&type=script&lang=js&"
import style0 from "./BaseLabelWithPopover.vue?vue&type=style&index=0&id=768a488c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768a488c",
  null
  
)

export default component.exports